export default async function retrieveConfigSettings(context) {
	const { service } = context;

	// Searches must be loaded only after the configuration settings have been fully loaded,
	// as the display of the searches is dependent on these settings.
	service.retrieveConfigSettings({}, () => {
		service.retrieveSearches();
	});
}
